import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=5b64767a&"
import script from "./UserTag.vue?vue&type=script&lang=js&"
export * from "./UserTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports